var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLinkBackDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-navigation/Back-small/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.22426667,13.3242 C6.04493333,13.3242 5.86693333,13.2528667 5.73626667,13.1115333 L0.178266667,7.1242 C-0.0590666667,6.86886667 -0.0590666667,6.4742 0.1776,6.2182 L5.7356,0.2142 C5.98426667,-0.0564666667 6.40693333,-0.0731333333 6.6776,0.177533333 C6.9476,0.427533333 6.9636,0.849533333 6.71293333,1.11953333 L1.5756,6.6702 L6.71226667,12.2035333 C6.96293333,12.4742 6.9476,12.8955333 6.67826667,13.1455333 C6.5496,13.2648667 6.38693333,13.3242 6.22426667,13.3242",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-navigation/Back-small/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLinkBackDarkblue);
export default __webpack_public_path__ + "static/media/arrow-link-back-darkblue.cec51dc76105a1946d025ccb62ab127b.svg";
export { ForwardRef as ReactComponent };